import axios from "axios";

/**
 * URL base de la API.
 *
 * Usamos SIEMPRE rutas relativas ("/api"). Tanto en preview como en producción
 * el frontend y el backend viven bajo el mismo dominio y el ingress redirige
 * `/api/*` al backend. Esto evita problemas de CORS y garantiza que el bundle
 * publicado en asatta.org NO intente hablar con la URL de preview de Emergent.
 *
 * Si en el futuro se necesita apuntar a un backend externo, exportar
 * REACT_APP_BACKEND_URL en el build sobreescribirá este comportamiento.
 */
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
// En producción y preview usamos rutas relativas; si (y sólo si) alguien
// define explícitamente REACT_APP_BACKEND_URL_ABSOLUTE=true se usará la env.
const USE_ABSOLUTE =
    (process.env.REACT_APP_BACKEND_URL_ABSOLUTE || "").toLowerCase() === "true";

export const API_URL = USE_ABSOLUTE && BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

const api = axios.create({
    baseURL: API_URL,
    withCredentials: true,
});

export default api;

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Ha ocurrido un error. Inténtalo de nuevo.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
